var _style, _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.4,
    y: 28,
    className: "st1",
    width: 21.8,
    height: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55,52l-4.8-4.5l6.7-0.9l3-5.8l2,3.9c2.4-4,1.8-10-1.4-13.3c-3.9-3.9-10.2-3.9-14,0c-3.5,3.5-3.9,10.1-0.9,14 l7.9,11.5l1.1-1.6L55,52z M53.4,34.9c1.8,0,3.3,1.5,3.3,3.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3 C50.1,36.4,51.6,34.9,53.4,34.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.1,44.2l2,4l4.5,0.6l-3.3,3.1l0.8,4.3l-4.1-2.1L56,56.2l0.8-4.3l-3.3-3.1l4.5-0.6L60.1,44.2z M60.1,44.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsDefault);
export default __webpack_public_path__ + "static/media/locations-default.167a02dfbfe364c0453b83180a5a30d1.svg";
export { ForwardRef as ReactComponent };